import React from 'react';
import type { DropdownIndicatorProps, GroupBase } from 'react-select';

const DropdownIndicator = <
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>,
>({
    className,
    cx,
    innerProps,
}: DropdownIndicatorProps<Option, IsMulti, Group>) => (
    <div {...innerProps} className={cx({ indicator: true, 'dropdown-indicator': true }, className)}>
        <svg width="23" height="23" viewBox="0 0 20 20">
            <path d="m9.99457 14.1689-1.17062-1.1706-4.66041-4.67143 1.17062-1.17062 4.66041 4.66045L14.666 7.15625l1.1706 1.17062-4.6604 4.67143-1.18163 1.1706Z" />
        </svg>
    </div>
);

export default DropdownIndicator;
